module.exports = __webpack_public_path__ + "static/media/phone2x.501c2b04.png";